import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FieldTeamLayout from './FieldTeamLayout';
import LiveMap from './LiveMap';
import Timeline from './Timeline';
import TeamManagement from './TeamManagement';
import Targets from './Targets';
import Meetings from './Meetings';
import Clients from './Clients';
import Invoices from './Invoices';
import Commission from './Commission';
import Clearance from './Clearance';
import Reports from './Reports';
import MemberDetail from './MemberDetail';

function FieldTeamRoutes() {
  return (
    <FieldTeamLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/field-team/live-map" replace />} />
        <Route path="/live-map" element={<LiveMap />} />
        <Route path="/timeline" element={<Timeline />} />
        <Route path="/team" element={<TeamManagement />} />
        <Route path="/targets" element={<Targets />} />
        <Route path="/meetings" element={<Meetings />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/commission" element={<Commission />} />
        <Route path="/clearance" element={<Clearance />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/member/:id" element={<MemberDetail />} />
      </Routes>
    </FieldTeamLayout>
  );
}

export default FieldTeamRoutes;
